export var logger = console_action();
logger.warn = console_action('warn');
logger.error = console_action('error');
function console_action(type) {
    if (type === void 0) { type = 'log'; }
    return function (log, data, debug) {
        if (data === void 0) { data = ''; }
        if (debug === void 0) { debug = false; }
        if (typeof data === 'object') {
            data = JSON.stringify(data);
        }
        if (debug) {
            console[type](log + data);
        }
    };
}
